<h2 mat-dialog-title>Edytuj kontrakt cenowy</h2>
<div mat-dialog-content>
    <div class="mv-m" fxLayout="row" fxLayoutAlign="align center">
        <p fxFlex="40%">Cena</p>
        <label fxFlex="60%" fxLayout="row" fxLayoutAlign="align center">
            <mat-form-field fxFlex="80%">
                <input type="number" matInput class="input-number" [value]="priceValue" (blur)="priceOnBlur($event)" step="0.01" min="0.01">
            </mat-form-field>
            <span class="ml-xxs" fxFlex="20%">zł</span>
        </label>
    </div>
    <div class="mv-m" fxLayout="row" fxLayoutAlign="align center">
        <p fxFlex="40%">Typ kontraktu</p>
        <mat-select fxFlex="60%" class="sim-rl-dropdown" placeholder="Wybierz typ kontraktu" [value]="selectedContract" (selectionChange)="selectedContractChange($event)">
            <mat-option [value]="0">
                Stała cena produktu
            </mat-option>
            <mat-option [value]="1">
                Minimalna cena produktu
            </mat-option>
            <mat-option [value]="2">
                Maksymalna cena produktu
            </mat-option>
        </mat-select>
    </div>
    <div class="mv-m" fxLayout="row" fxLayoutAlign="align center">
        <p fxFlex="40%">Data zobowiązywania</p>
        <mat-form-field appearance="fill" fxFlex="60%">
            <mat-label>Początek - Koniec</mat-label>
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="rrrr-mm-dd">
                <input matEndDate formControlName="end" placeholder="rrrr-mm-dd">
            </mat-date-range-input>

            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Niepoprawna data początku zobowiązywania</mat-error>
            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Niepoprawna data końca zobowiązywania</mat-error>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions fxLayout="row">
    <button-spinner class="ml-xm" [inProgress]="updating">
        <button mat-button [disabled]="updating" (click)="onNoClick()">Zamknij</button>
        <button mat-button [disabled]="updating" (click)="updatePriceContractClick()">Zapisz kontrakt</button>
    </button-spinner>
</div>
